import { NgModule } from '@angular/core'
import { CustomAddToCartComponent } from './custom-add-to-cart.component'
import { CustomAddedToCartDialogComponent } from './custom-added-to-cart-dialog/custom-added-to-cart-dialog.component'
import { CmsConfig, I18nModule, provideConfig, UrlModule } from '@spartacus/core'
import { CommonModule } from '@angular/common'
import { IconModule, ItemCounterModule, OutletModule, SpinnerModule } from '@spartacus/storefront'
import { NgSelectModule } from '@ng-select/ng-select'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MaterialModule } from '../../shared/material.module'
import { CustomCartSharedModule } from '../cart-shared/custom-cart-shared.module'
import { CustomButtonModule } from '../../shared/custom-components/custom-button/custom-button.module'
import { RouterLink } from '@angular/router'
import { customAddedToCartLayoutConfig } from './custom-added-to-cart-dialog/custom-added-to-cart-layout.config'

@NgModule({
  declarations: [CustomAddToCartComponent, CustomAddedToCartDialogComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    I18nModule,
    IconModule,
    ItemCounterModule,
    OutletModule,
    NgSelectModule,
    FormsModule,
    MaterialModule,
    CustomCartSharedModule,
    CustomButtonModule,
    UrlModule,
    RouterLink,
    SpinnerModule
  ],
  providers: [
    provideConfig(customAddedToCartLayoutConfig),
    provideConfig(<CmsConfig>{
      cmsComponents: {
        AddedToCartDialogComponent: {
          component: CustomAddedToCartDialogComponent
        },
        ProductAddToCartComponent: {
          component: CustomAddToCartComponent
        }
      }
    })
  ],
  exports: [CustomAddToCartComponent]
})
export class CustomAddToCartModule {}
